import { render, staticRenderFns } from "./TermosdeUso.vue?vue&type=template&id=efee613a&scoped=true"
import script from "./TermosdeUso.vue?vue&type=script&lang=js"
export * from "./TermosdeUso.vue?vue&type=script&lang=js"
import style0 from "./TermosdeUso.vue?vue&type=style&index=0&id=efee613a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efee613a",
  null
  
)

export default component.exports